import LocalizedStrings from "react-localization";

export const creativeClassificationStrings = new LocalizedStrings({
  en: {},
  fr: {},
});
